export const AUTHORIZED = 'bintu-auth';
export const BINTU_MAIL = 'bintu-mail';
export const BINTU_APIKEY = 'bintu-apikey';
export const BINTU_ORGA = 'bintu-orga';
export const H5LIVE_HASH_SECURE = 'h5live-security';